import Factory from "../Factory";
import { FactoryInterface } from "../FactoryInterface";

import { Payment } from "../Entities/Payment/Payment";
import { PaymentInterface } from "../Entities/Payment/PaymentInterface";

import CurrencyContainer from "../../Currency/CurrencyContainer";
import Store from "../../Store/Store";

import { ChargeInterface } from "../Entities/Charge/ChargeInterface";
import ChargeFactory from "./ChargeFactory";

class PaymentFactory extends Factory implements FactoryInterface {
  public create(data: any): PaymentInterface {
    const linkedCharges: ChargeInterface[] = !!data.linkedCharges && data.linkedCharges.map(charge => charge?.id && ChargeFactory.create(charge));
    const relatedCharges: ChargeInterface[] = !!data.relatedCharges && data.relatedCharges.map(charge => charge?.id && ChargeFactory.create(charge));

    return new Payment({
      id: data.id,
      amount: data.amount,
      amountUsed: data.amountUsed,
      description: data.description ? data.description : "",
      parsedTransactionDescription: data.parsedTransactionDescription,
      firstDateOfStatementPeriod: data.firstDateOfStatementPeriod ? new Date(data.firstDateOfStatementPeriod) : null,
      currency: CurrencyContainer.pickFromId(data.currencyId),
      paymentType: Store.getConfigurator().getState().globalTypes?.PaymentType?.[data.paymentTypeId],
      paymentClass: Store.getConfigurator().getState().globalTypes?.PaymentClass?.[data.paymentClassId],
      creationType: Store.getConfigurator().getState().globalTypes?.PaymentCreationType?.[data.creationType],
      ledgerAccountId: data.ledgerAccountId || "",
      bankTransactionId: data.bankTransactionId || "",
      reference: data.reference || "",
      personId: data.contactId,
      companyId: data.companyId,
      amountDetails: data.amountDetails,
      transactionDetails: data.transactionDetails,
      chargeIds: Object.keys(data?.amountDetails || {}),
      linkedCharges: linkedCharges || [],
      relatedCharges: relatedCharges || [],
      createdAt: new Date(data.createdAt),
      removed: data.removed,
      isLocked: data.isLocked,
      isSettle: data.isSettle,
      mainBankAccountId: data.mainBankAccountId,
      agencyBankAccount: data.agencyBankAccount,
      transactionFileId: data.transactionFileId,
      name: data.name,
      dateOfThePayment: data.dateOfThePayment ? new Date(data.dateOfThePayment) : null,
      transactionFile: data.transactionFile,
      note: data.note || "",
      isProcessed: data.isProcessed,
      isSnoozed: data.isSnoozed,
      isRefunded: data.isRefunded,
      isReferencedToSavings: data.isReferencedToSavings,
      hasMemos: data.hasMemos,
      ownerFinancialStatementId: data.ownerFinancialStatementId,
      isPaidDirectlyToOwner: data.isPaidDirectlyToOwner,
      isClosedInStatement: data.isClosedInStatement,
    });
  }

  public reinitialize(data: any): PaymentInterface {
    return new Payment({
      ...data
    });
  }
}

export default new PaymentFactory();
